import { useIntl } from 'react-intl';

export const useCohortAttritionHeaderMessageKeys = () => {
  const intl = useIntl();

  return {
    stepTitle: intl.formatMessage({ id: 'cohortAttritionTab.stepTitle' }),
    stepDescription: intl.formatMessage({ id: 'cohortAttritionTab.stepDescription' }),
  };
};
